import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalserviceService } from 'src/app/helpers/services/localservice.service';
import { Constant } from 'src/app/helpers/constants/constant';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { SharedAlertModelComponent } from 'src/app/common-shared-modules/shared-alert-model/shared-alert-model.component';
import { AlertSwipeComponent } from 'src/app/common-shared-modules/alert-swipe/alert-swipe.component';

@Component({
  selector: 'app-group-renewal-download-api',
  templateUrl: './group-renewal-download-api.component.html',
  styleUrls: ['./group-renewal-download-api.component.css']
})
export class GroupRenewalDownloadApiComponent implements OnInit {
  form: FormGroup;
  loading = false;
  submitted = false;
  fileName = "Group-Policy-no-"
  auth = {
    policynumber: '',
    dob: '',
    txtMobileNumber: '',
    otpvalue: ''
  };
  genrateOtp = true;
  downloadCOI = false;
  refernceNumber: any;
  OTPText = "OTP Send Successfully";
  editCOIMobile = true;
  usertoken: any;

  // private alertSwipe =new AlertSwipeComponent()
  @ViewChild(AlertSwipeComponent) private alertSwipe:
    AlertSwipeComponent;
  messageObj: any;

  constructor(private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    public appservice: LocalserviceService,
    public matDialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      policyNo: ['', Validators.required],
      dob: ['', Validators.required],
      txtMobileNumber: ['', Validators.required],
      otpvalue: ['', Validators.required]

    });


    if (this.appservice.subsVar == undefined) {
      this.appservice.subsVar = this.appservice.
        invokeParenComponentFunction.subscribe((name: string) => {
        });
    }
  }

  GenrateOTP(auth, form, otpMsg) {
    var mobilePattern = /^[6789]\d{9}$/;
    var mobileNoPattern = (form.value.txtMobileNumber == "" || form.value.txtMobileNumber == undefined) ? true : (mobilePattern.test(form.value.txtMobileNumber));
    if (mobileNoPattern == false) {
      this.messageObj = {
        "messageVal": "Please enter valid mobile number.",
        "classVal": "e",
        "showAlertSwipe": true
      }
      this.alertSwipe.sliderAlertSwipe(this.messageObj)
    } else {
      if (form.value.txtMobileNumber == "") {
        this.messageObj = {
          "messageVal": "Please enter mobile number.",
          "classVal": "e",
          "showAlertSwipe": true
        }
        this.alertSwipe.sliderAlertSwipe(this.messageObj)
      } else {
        var loginObj = {
          "ReferenceNumber": "",
          "MobileNumber": this.auth.txtMobileNumber,
          "COINumber": this.auth.policynumber
        }
        const headernew = {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Access-Control-Allow-Headers': 'Content-Type',
          'x-ob-at': Constant.x_ob_at,
          'x-ob-ut': '',
        };
        this.appservice.show()
        this.appservice.PostApi(Constant.hpre_BaseUrl + '/api/groupRenew/RequestOTP', loginObj, headernew).subscribe(res => {
          console.log(res)
          this.appservice.hide()
          if (res.ResponseCode == '1') {
            var coiDetail = res.ResponseData;
            this.refernceNumber = coiDetail.ReferenceNumber
            this.genrateOtp = false;
            this.downloadCOI = true;
            this.editCOIMobile = false;
            if (otpMsg) {
              this.OTPText = "OTP Re-Send Successfully";
            }
            const alertModel = new MatDialogConfig();
            alertModel.disableClose = true;
            alertModel.id = "modal-component";
            alertModel.height = "245px";;
            alertModel.width = "480px";
            alertModel.data = {
              title: "Alert Model",
              description: res.ResponseMessage,
              successText: "OK",
              failureText: "cancel",
              showSuccessBtn: true,
              showFaliureBtn: true,
            }
            const modalDialog = this.matDialog.open(SharedAlertModelComponent, alertModel);
            sessionStorage.setItem('ut', coiDetail.ut);
          } else if (res.ResponseCode == '0') {
            var errorMessage = res.ResponseData != null ? res.ResponseData.ErrorMessage : res.ResponseMessage
            const alertModel = new MatDialogConfig();
            alertModel.disableClose = true;
            alertModel.id = "modal-component";
            alertModel.height = "245px";
            alertModel.width = "480px";
            alertModel.data = {
              title: "Alert Model",
              description: errorMessage,
              successText: "OK",
              failureText: "cancel",
              showSuccessBtn: true,
              showFaliureBtn: true,

            }

            const modalDialog = this.matDialog.open(SharedAlertModelComponent, alertModel);
          }

        })

      }

    }
  }

  /*-----------------------to validate form and check login--------------------*/

  /* ******************************verify OTP*********************************** */

  verifyOTP(otp) {
    //this.usertoken = sessionStorage.getItem('ut');
    var otpPattern = /^[0-9]+$/;
    var mobileNoPattern = (otp == "" || otp == undefined) ? true : (otpPattern.test(otp));
    if (mobileNoPattern == false) {
      this.messageObj = {
        "messageVal": "Please enter valid OTP.",
        "classVal": "e",
        "showAlertSwipe": true
      }
      this.alertSwipe.sliderAlertSwipe(this.messageObj)
    } else {
      this.appservice.show()
      this.appservice.PostApi(Constant.hpre_BaseUrl + '/api/groupRenew/VerifyOTP', { "ReferenceNumber": this.refernceNumber, "COINumber": this.auth.policynumber, "OTP": otp }, Constant.header).subscribe(res => {
        console.log(res)
        this.appservice.hide()
        if (res.ResponseCode == '1') {
          var coiDetail = res.ResponseData;
          if (coiDetail.ErrorMessage != "Success") {
            const alertModel = new MatDialogConfig();
            alertModel.disableClose = true;
            alertModel.id = "modal-component";
            alertModel.height = "245px";
            alertModel.width = "480px";
            alertModel.data = {
              title: "Alert Model",
              description: coiDetail.ErrorMessage,
              successText: "OK",
              failureText: "cancel",
              showSuccessBtn: true,
              showFaliureBtn: true,

            }
            const modalDialog = this.matDialog.open(SharedAlertModelComponent, alertModel);
          } else {
            for (var i = 0; i <= coiDetail.groupSearchDownloads.length; i++) {
              var ByteArray = coiDetail.groupSearchDownloads[i].ByteArray;
              this.fileName = this.fileName + coiDetail.groupSearchDownloads[i].CertificateNumber;
              const source = `data:application/pdf;base64,${ByteArray}`;
              const link = document.createElement("a");
              link.href = source;
              link.download = `${this.fileName}.pdf`
              link.click();
              this.fileName = null;
              this.fileName = "Group-Policy-no-"
            }
          }
        } else if (res.ResponseCode == '0') {
          var errorMessage = res.ResponseData != null ? res.ResponseData.ErrorMessage : res.ResponseMessage
          const alertModel = new MatDialogConfig();
          alertModel.disableClose = true;
          alertModel.id = "modal-component";
          alertModel.height = "245px";
          alertModel.width = "480px";
          alertModel.data = {
            title: "Alert Model",
            description: errorMessage,
            successText: "OK",
            failureText: "cancel",
            showSuccessBtn: true,
            showFaliureBtn: true,

          }
          const modalDialog = this.matDialog.open(SharedAlertModelComponent, alertModel);
        }

      })
    }

  }

  /* ******************************verify OTP*********************************** */

  onSuccess() {

  }

  EditCOIMobile() {
    this.form.controls['txtMobileNumber'].enable();
    this.form.controls['policyNo'].enable();
    this.genrateOtp = true;
    this.downloadCOI = false;
    this.editCOIMobile = true;
  }
}
